// src/components/Home/AuthorStorySection.tsx
import React from 'react';
import {ReactComponent as Bg} from 'src/assets/home/homeImg.svg';
import {useIsMobile} from "../../../../hooks/useIsMobile";

const AuthorStorySection: React.FC = () => {
    const isMobile = useIsMobile();


    return (
        <section className="px-4  md:px-8 bg-white">
        <div className="flex flex-col max-w-7xl mx-auto gap-[30px] md:gap-3">
            <h2 className="text-[30px] md:text-lg font-normal text-center  text-[#111827]">
                작가의 이야기가 독자에게로,
            </h2>

            <h1 className="text-[36px] md:text-[22px] font-extrabold text-center  text-[#111827]">
                북밋의 시작
            </h1>

            <div className="w-[96px] md:w-[72px] h-[4px] bg-main mx-auto"></div>
            <div className={`mt-[65px] md:mt-[33px] flex ${isMobile ? 'flex-col' : 'md:flex-row'} mx-auto gap-12 md:gap-2`}>

                {isMobile && (

                        <div className="relative w-full h-full flex items-center justify-center">
                            <Bg className="w-full h-auto"/>

                            <div
                                className="absolute z-10 min-w-[275px]  min-h-[101px] bottom-12  mx-11  mb-6 md:mb-2 py-3 px-6 md:py-1 md:px-4 flex flex-col bg-white/90 rounded-3 gap-2 ">

                                <div className={"flex flex-row gap-3 items-center justify-center"}>
                                    <div
                                        className={"flex w-[29px] h-12 py-3 md:h-10 px-[10px] md:px-2 justify-center items-center bg-main rounded-full"}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16"
                                             viewBox="0 0 15 16" fill="none" className={"md:w-3 h-3"}>
                                            <g clip-path="url(#clip0_5003_7778)">
                                                <path
                                                    d="M0.734375 6.75C0.734375 4.67812 2.4125 3 4.48438 3H4.73438C5.2875 3 5.73438 3.44687 5.73438 4C5.73438 4.55313 5.2875 5 4.73438 5H4.48438C3.51875 5 2.73438 5.78437 2.73438 6.75V7H4.73438C5.8375 7 6.73438 7.89687 6.73438 9V11C6.73438 12.1031 5.8375 13 4.73438 13H2.73438C1.63125 13 0.734375 12.1031 0.734375 11V10V9V6.75ZM8.73438 6.75C8.73438 4.67812 10.4125 3 12.4844 3H12.7344C13.2875 3 13.7344 3.44687 13.7344 4C13.7344 4.55313 13.2875 5 12.7344 5H12.4844C11.5188 5 10.7344 5.78437 10.7344 6.75V7H12.7344C13.8375 7 14.7344 7.89687 14.7344 9V11C14.7344 12.1031 13.8375 13 12.7344 13H10.7344C9.63125 13 8.73438 12.1031 8.73438 11V10V9V6.75Z"
                                                    fill="white"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_5003_7778">
                                                    <path d="M0.734375 0H14.7344V16H0.734375V0Z" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <span className={"text-[#1F2937] text-sm md:text-xs font-normal leading-6 md:leading-[19px]"}>
                                    북페어에 나가도 작품을 알리거나 판매가 쉽진 않고, 엽서는 독자분들이 좋아하시지만 홍보로 이어질지는 모르겠어요.
                                </span>
                                </div>


                                <div className={"flex flex-col justify-end items-end"}>
                                    <span
                                        className={"text-[#92979F] text-xs md:text-[10px] font-normal leading-[20px]"}> - 익명의 독립출판 작가 </span>
                                </div>

                            </div>






                        </div>


                )}


                <div className={"flex flex-col gap-8 md:gap-4 mt-7 md:mt-0 mx-auto"}>
                    <div
                        className={"p-8 md:p-[14px] w-[528px] md:w-full rounded-[16px] border-[1px] border-[#19CF7A1A] bg-[#19CF7A0D]"}>
                        <p className={"text-2xl md:text-base text-[#111827] font-bold"}>
                            작품 홍보에 대한 어려움
                        </p>
                        <span className={"text-lg leading-[30px] md:text-sm font-normal md:leading-[26px]"}>
                             독립출판물과 신인 작가의 작품은 기존에 없던 새로운 시각을 담고 있죠. 하지만 홍보비 부담과 방법의 한계로, 독자들에게 닿지 못하는 경우가 많습니다.

                        </span>
                    </div>

                    <div className={"p-8 md:p-4 w-[528px] md:w-full rounded-[16px]  border-0 bg-[#F5F5F5]"}>
                        <p className={"text-2xl md:text-base text-[#111827] font-bold"}>
                            북밋에서 자유롭게 내 이야기를 펼쳐 보세요
                        </p>

                        <span className={"text-lg leading-[30px] md:text-sm font-normal md:leading-[26px]"}>
                        북밋은 독립출판작가들이 작품을 알리고, 독자와 직접 연결되는
                        공간입니다. 이곳에서 나만의 이야기를 펼치고, 독자와 소통해 보세요!
                        </span>
                    </div>

                </div>


                {!isMobile && (

                    <div className="w-full">
                        <div className="relative w-full h-full flex items-center justify-center">
                            <Bg className="w-[528px] h-[500px]"/>

                            <div
                                className="absolute z-10 bottom-12  mx-12 mb-9 py-4 px-6 flex flex-col bg-white/90 rounded-3 gap-2">

                                <div className={"flex flex-row gap-4"}>
                                    <div
                                        className={"flex w-[35px] h-12 py-3 px-[10px] justify-center items-center bg-main rounded-full"}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16"
                                             viewBox="0 0 15 16" fill="none">
                                            <g clip-path="url(#clip0_5003_7778)">
                                                <path
                                                    d="M0.734375 6.75C0.734375 4.67812 2.4125 3 4.48438 3H4.73438C5.2875 3 5.73438 3.44687 5.73438 4C5.73438 4.55313 5.2875 5 4.73438 5H4.48438C3.51875 5 2.73438 5.78437 2.73438 6.75V7H4.73438C5.8375 7 6.73438 7.89687 6.73438 9V11C6.73438 12.1031 5.8375 13 4.73438 13H2.73438C1.63125 13 0.734375 12.1031 0.734375 11V10V9V6.75ZM8.73438 6.75C8.73438 4.67812 10.4125 3 12.4844 3H12.7344C13.2875 3 13.7344 3.44687 13.7344 4C13.7344 4.55313 13.2875 5 12.7344 5H12.4844C11.5188 5 10.7344 5.78437 10.7344 6.75V7H12.7344C13.8375 7 14.7344 7.89687 14.7344 9V11C14.7344 12.1031 13.8375 13 12.7344 13H10.7344C9.63125 13 8.73438 12.1031 8.73438 11V10V9V6.75Z"
                                                    fill="white"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_5003_7778">
                                                    <path d="M0.734375 0H14.7344V16H0.734375V0Z" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <span className={"text-[#1F2937] text-base font-normal leading-6"}>
                                   북페어에 나가도 작품을 알리거나 판매가 쉽진 않고, 엽서는 독자분들이 좋아하시지만 홍보로 이어질지는 모르겠어요.
                                </span>
                                </div>


                                <div className={"flex flex-col justify-end items-end"}>
                                 <span className={"text-[#92979F] text-sm font-normal leading-[20px]"}> - 익명의 독립출판 작가 </span>
                                </div>


                            </div>
                        </div>
                    </div>


                )}

            </div>

        </div>
        </section>
    );
};

export default AuthorStorySection;
